import { render, staticRenderFns } from "./SectionCompanyProfile.vue?vue&type=template&id=ee803af2&scoped=true"
import script from "./SectionCompanyProfile.vue?vue&type=script&lang=ts"
export * from "./SectionCompanyProfile.vue?vue&type=script&lang=ts"
import style0 from "./SectionCompanyProfile.vue?vue&type=style&index=0&id=ee803af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee803af2",
  null
  
)

export default component.exports